/** System notifications: only when granted and the app is in the background (spec §3.5 Behaviour). */
export async function ensureNotificationPermission(): Promise<boolean> {
  if (typeof Notification === 'undefined') return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  return (await Notification.requestPermission()) === 'granted';
}

export function notifyInBackground(title: string, body: string) {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted' || !document.hidden) return;
  try { new Notification(title, { body, icon: '/icons/icon-192x192.png', tag: 'timato-session' }); } catch { /* unsupported in this context */ }
}
